/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-05-12 17:42:09
 * description  : 描述
 * author       : zhizhan
 */

import React from "react";
import BaseUpload from "../BaseUpload";
import { ossValueFromHandle } from "../tools";
import { YxComponent } from "../../../YxComponent";
import { get, random, merge, toArray } from "../../../../utils";
import UploadHuawei from "../Upload-huawei";
import UploadFileAws from "../../../../utils/upload/uploadFileAws";

/**
 * minio
 *
 * @class UploadMini
 * @extends {YxComponent}
 */
class UploadMini extends UploadHuawei {
  constructor(props, context) {
    super(props, context);
    this.uploadFile = get(
      this.props,
      "uploadFile",
      new UploadFileAws(this.props)
    );
    this.id = random();
  }

  render() {
    return <BaseUpload {...this.param} />;
  }
}

export default UploadMini;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Upload-minio/index.js